import { Col, Form, Row, Select } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { SuccessNotificationMsg } from "../../utils/Notifications";

const { Option } = Select;

const MultipleConfirmDeliveryPartnerAssignment = ({
  closeModal,
  record,
  selectedRow,
  setReload,
  setSelectedRow,
  getCurrentLocation,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();

  const [companyList, setCompanyList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [companyId, setCompanyId] = useState(null);

  // Fetch company list
  const getCompanyName = async () => {
    try {
      const response = await getRequest("company/?no_pagination=true");
      setCompanyList(response.data.data);
    } catch (error) {
      console.log("Error fetching company list:", error);
    }
  };

  useEffect(() => {
    getCompanyName();
  }, []);

  // Handle company selection
  const handleCompanySelectChange = (value) => {
    setCompanyId(value);
    formRef.current.setFieldsValue({ company_id: value });
  };

  // Reset form
  const handleReset = () => {
    setCompanyId(null);
    formRef.current.resetFields();
  };

  // Cancel
  const handleCancel = () => {
    handleReset();
    closeModal();
  };

  // Submit
  const handleSubmit = async () => {
    setBtnLoading(true);

    const location = await getCurrentLocation();

    const payload = {
      company_id: companyId,
      packages: selectedRow,
      ...(location?.latitude && { latitude: location.latitude }),
      ...(location?.longitude && { longitude: location.longitude }),
    };

    try {
      const response = await postRequest(
        "package-model/assign-delivery-partner/",
        payload
      );

      if (response.data.success) {
        SuccessNotificationMsg(
          t("Assign Package To Delivery Partner Successfully")
        );
        setSelectedRow([]);
        setReload((prev) => !prev);
      }

      handleReset();
      closeModal();
    } catch (error) {
      setReload((prev) => !prev);
      handleReset();
      closeModal();
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div className="optimize-modal">
      <Form ref={formRef} onFinish={handleSubmit}>
        <Row gutter={16} justify="center">
          <Col
            xs={24}
            md={16}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Form.Item
              name="company_id"
              label="Client"
              style={{ width: "100%", maxWidth: "300px" }}
              rules={[
                {
                  required: true,
                  message: t("Please select a client!"),
                },
              ]}
            >
              <Select
                placeholder={t("val_company")}
                showSearch
                optionFilterProp="children"
                onChange={handleCompanySelectChange}
              >
                {companyList.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.company_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} className="modlbtnrow">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label="Cancel"
              onClick={handleCancel}
            />

            <ButtonField
              type="primary"
              className="SaveGradiantBtn"
              htmlType="submit"
              label={t("save")}
              loading={btnLoading}
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

MultipleConfirmDeliveryPartnerAssignment.propTypes = {
  closeModal: PropTypes.func,
  record: PropTypes.object.isRequired,
  selectedRow: PropTypes.array,
  setReload: PropTypes.func,
  setSelectedRow: PropTypes.func,
  getCurrentLocation: PropTypes.func,
};

export default MultipleConfirmDeliveryPartnerAssignment;